import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'

const firebaseConfig = {
  apiKey: "AIzaSyDf3aeft1F1a8o5K80cwRA23exk98-D7EA",
  authDomain: "minsu-journ.firebaseapp.com",
  projectId: "minsu-journ",
  storageBucket: "minsu-journ.firebasestorage.app",
  messagingSenderId: "491091434927",
  appId: "1:491091434927:web:6758d9f1a17f892451235a",
  measurementId: "G-MZCXTCRHN3"
}
const app = initializeApp(firebaseConfig)
const db = getFirestore(app)

export { db }